import { Place, PLACE_TYPE } from '../PlacesAutocomplete.types';

interface PlacePredictionText {
  text: string;
}

export interface GooglePlacePrediction {
  placeId: string;
  text: PlacePredictionText;
  mainText?: PlacePredictionText;
  secondaryText?: PlacePredictionText;
}

export const adaptGoogleSuggestionsToPlaces = (
  suggestions: Array<{ placePrediction?: GooglePlacePrediction }>,
): Place[] => {
  return suggestions
    .map((suggestion) => suggestion.placePrediction)
    .filter((prediction) => !!prediction)
    .map((prediction) => {
      const secondaryText = prediction.secondaryText?.text;

      return {
        id: prediction.placeId,
        mainText: prediction.mainText?.text ?? prediction.text.text,
        ...(secondaryText ? { secondaryText } : {}),
        description: prediction.text.text,
        originType: PLACE_TYPE.GOOGLE,
      };
    });
};
